import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import RowAddButton from '@/components/buttons/RowAddButton';
import NoRows from '@/components/table/NoRows';
import CompactTableHeader from '@/components/table/CompactTableHeader';
import fetch from '@/hooks/fetch';
import { datasetPermissions } from '../../sharing/constants';
import { fetchDatasetCollections, showAddDatasetCollections } from '../actions';
import { datasetPerms } from '../../sharing/state/state';
import DatasetSettingsTable from '../../settings/components/DatasetSettingsTable';
import DatasetSettingsTableLoader from '../../settings/components/DatasetSettingsTableLoader';
import findDatasetCollectionEntities from '../helper';
import DatasetCollectionRows from '../components/DatasetCollectionRows';

const DatasetCollectionsTable = ({
  canAdd,
  category,
  code,
  collections,
  fetchData,
  isLoading,
  name,
  readStatus,
  showAdd,
}) => {
  fetch.useFetchByCode(fetchData, category, code, readStatus);
  if (isLoading) {
    return (
      <DatasetSettingsTableLoader />
    );
  }

  if (!collections || collections.length === 0) {
    return (
      <NoRows
        onClick={canAdd ? () => showAdd(category, code, name) : undefined}
        entity="dataset.collection"
        className="min-h-35"
      />
    );
  }

  return (
    <DatasetSettingsTable>
      {canAdd && (
      <Table.Header>
        <CompactTableHeader numberOfColumns={2}>
          <RowAddButton
            entity="dataset.collection"
            onClick={() => showAdd(category, code, name)}
            dataPosition="left center"
            size="mini"
          />
        </CompactTableHeader>
      </Table.Header>
      )}
      <Table.Body>
        <DatasetCollectionRows category={category} code={code} collections={collections} name={name} />
      </Table.Body>
    </DatasetSettingsTable>
  );
};

const withoutItemLoaded = (item) => (
  {
    readStatus: item?.readStatus || states.NONE,
    readErrors: [],
    collections: [],
    isLoading: false,
    canAdd: false,
  }
);

const withItemLoaded = (datasetCollection, collections, canAdd) => ({
  readStatus: datasetCollection.readStatus,
  readErrors: [],
  collections: collections.results,
  isLoading: datasetCollection.readStatus === states.PENDING,
  canAdd,
});

const mapStateToProps = ({
  auth: { role },
  datasetCollections: { datasetCollections },
  datasetUsers: { permissions },
}, { category, code }) => {
  const item = findResult(datasetCollections, category, code);
  const collections = findDatasetCollectionEntities(datasetCollections, code);
  const permission = findResult(permissions, 'open', code) || datasetPerms();
  const canAddCollectionAdmin = role.permissions.collections.datasets;
  const canAddDataOwner = permission[datasetPermissions.COLLECTIONS];
  const canAdd = canAddCollectionAdmin || canAddDataOwner;

  return (item?.readStatus === states.SUCCESS || item?.readStatus === states.ERROR)
    ? withItemLoaded(item, collections, canAdd) : withoutItemLoaded(item);
};

const mapDispatchToProps = {
  fetchData: fetchDatasetCollections,
  showAdd: showAddDatasetCollections,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetCollectionsTable);
